export interface IRouteMeta {
	requiresAuth: boolean;
	namePage?: string;
	descPage?: string;
	[key: string]: any;
}

export interface IRouteMetadata {
	[key: string]: IRouteMeta;
}

export interface IFirebaseConfig {
	apiKey: string;
	authDomain: string;
	projectId: string;
	storageBucket: string;
	messagingSenderId: string;
	appId: string;
}

export interface IModal {
	modalToShow: string | null;
}

export interface IModalPayload {
	id?: string;
	device?: IDevice;
	subscriber?: ISubscriber;
  underlyingData?: {
    headerTitle: string,
    headers: string[],
    rows: string[][],
    /** Optional: link per row for navigation (e.g. /subscribers/123) */
    rowLinks?: string[]
  }
}

export type UserRole = 'user' | '';
export interface IUser {
  id: string,
  img?: string,
  email: string,
  name?: string,
  phone?: string,
  middleName?: string,
  lastName?: string,
  corporateId?: string,
  role?: UserRole,
  group?: string, 
  active?: boolean,
  permissions: {
    analytics?: boolean,
    admin?: boolean,
    сompanyProfile?: boolean,
    marketing?: boolean,
    uploadData?: boolean,
    subscriberList?: boolean,
    exportData?: boolean,
    manageTeam?: boolean,
    manageAllCompanies?: boolean,
  }
}

export type GroupType = 'insurance' | 'retail';
export type CustomerType = 'insurance' | 'retail';
export type SubscriptionStatus =
  | 'active'
  | 'trialing'
  | 'past_due'
  | 'canceled'
  | 'unpaid'
  | 'incomplete'
  | 'incomplete_expired'
  | 'paused';
export interface IGroup {
  id: string,
  name?: string,
  img?: string,
  type: GroupType
  root: string,
  activeSubscribers: number,
  created: number,
  reportUploadedDate: number,
  active: boolean,
  email?: string,
  phone?: string,
  deviceOption: DeviceType,
  billing: {
    name?: string,
    middleName?: string,
    lastName?: string,
    department?: string,
    title?: string,
    phone?: string,
    email?: string,
    billingEmail?: string,
  }
}

export enum NotificationTypes {
  Error = 'error',
  Info = 'info',
  Success = 'success',
  Warning = 'warning'
}

export interface NotificationInterface {
  notification: string,
  hash: number,
  type: NotificationTypes,
  timestamp: number
}

export interface ISubscriber {
  id: string,
  accountId?: number,
  insuranceId?: string,
  group?: string,
  customerType?: CustomerType,
  stripe_customer_id?: string,
  active?: boolean,
  created: number,
  name?: string,
  lastName?: string,
  email: string,
  phone?: string,
  sms_phone?: string,
  devices?: IDevice[],
  address: {
    address1?: string
    address2?: string
    city?: string,
    state?: string,
    zipCode?: string, 
  },
  delivery_address: {
    address1?: string
    address2?: string
    city?: string,
    state?: string,
    zipCode?: string, 
  },
  notifications: {
    name?: string;
    email?: string;
    phone?: string;
  }[]
}

export type DeviceDeliveryStatus = 'Shipped' | 'Shipping Delay' | 'Shipping Issue' | 'Delivered';

export interface IDevice {
  id: number,
  date_created: number,
  date_IMEI_assigned?: number,

  deviceIMEI?: string,
  deviceType: DeviceType,
  main_name?: string,
  zone2_name?: string,
  zone1_name?: string,

  activated?: boolean,
  date_activated?: number,

  device_address1?: string
  device_address2?: string
  device_city?: string,
  device_state?: string,
  device_zipCode?: string, 

  delivery_address1?: string
  delivery_address2?: string
  delivery_city?: string,
  delivery_state?: string,
  delivery_zipCode?: string, 

  tracking_number?: string,
  delivery_status?: DeviceDeliveryStatus,
  delivered_date?: number,
  shiped_date?: number,

  notifications_name_1?: string,
  notifications_email_1?: string,
  notifications_phone_1?: string,
  notifications_name_2?: string,
  notifications_email_2?: string,
  notifications_phone_2?: string,
  notifications_name_3?: string,
  notifications_email_3?: string,
  notifications_phone_3?: string,

  cases?: IAlertCase[],
  alerts?: IAlert[],
	groupIds?: string[],

  stripe_subscription_id?: string,
  subscription_status?: SubscriptionStatus | null,
  subscription_current_period_end?: number,
}

export interface IRegistrationInfo {
  name: string,
  lastName: string,
  email: string,
  phone: string,
  linkId?: number,
  password: string,
  address: {
    address1: string
    address2: string
    city: string,
    state: string,
    zipCode: string, 
  },
  delivery_address: {
    address1: string
    address2: string
    city: string,
    state: string,
    zipCode: string, 
  },
  notifications: {
    name: string;
    email: string;
    phone: string;
  }[]
}

export interface ISignUpLink {
  id: number,
  name?: string,
  fileUrl?: string,
  created: number,
  lastUsed: number,
  createdBy: string,
  subscribers: number,
  visited: number,
  groupId?: string,
}

export type DeviceType = 'single' | 'triple';

export interface IAlertCode {
  id: number,
  code: string,
  description: string,
  type: string,
}

export interface IAlert {
  id: number,
  date: number,
  imei: string,
  code: string,
  zone: string,
  location: string,
  value: string,
  details: IAlertCode,
  alertCases?: IAlertCase[],

	groupsIds?: string[],
	state?: string,
	sudId?: string,
	accountId?: number,
	name?: string,
	lastName?: string,
	zipCode?: string,
	status?: string,
	group?: IGroup,
	responceStatus?: AlertCaseResponceStatus,
	conclusion?: AlertCaseConclusion,
	// Computed fields
	isResolved?: boolean,
	relatedRestore?: {
		id: number,
		code: string,
		date: number,
		details?: IAlertCode
	} | null
}

export interface IAlertCase {
  id: number,
  type: AlertCaseType,
  status: AlertCaseStatus,
  created: number,
  alertId?: number,
  imei: string,
  lastAnswer?: number,
  lastActivity: number,
  notes?: ISubscriberTimelineItem[],
  details?: IAlertCode,
  conclusion?: AlertCaseConclusion,
  responceStatus?: AlertCaseResponceStatus,
  restored?: boolean,

	zipCode?: string,
	groupsIds?: string[],
	state?: string,
	group?: IGroup,
	name?: string,
	lastName?: string,
}

export type AlertCaseResponceStatus =
    'p' | // responded
    'n' | // not responded
    '' |
    null
;

export type AlertCaseStatus =
    'c'     | // new case
    'p'     | // positive
    'n'     | // negative
    'lbc2'  | // low battery ignore stage 2
    'tmc2'  | // temperature ignore stage 2
    'lcc2'  | // lost connection stage 2
    'wdc2'  | // water detected stage 2
    'wdwd'  | // water detected ask about water damage
    ''
;

export interface IHistoryLog {
  id: number,
  date: number,
  imei: string,
  simid: string,
  code: string,
  area: string,
  zone: string,
  batt: string,
  leak: string,
  temp: string,
  hitemp: string,
  lotemp: string,
  rssi: string,
  details: IAlertCode,
}

export type SubscriberTimelineItemType = 
  'c'  | // user comment
  's'  | // sms
  'sy' | // subscriber aknowlaged
  'sn' | // subscriber not aknowlaged
  'sr' | // subscriber restored
  'sd' | // subscriber not restored
  'sw' | // subscriber water damage
  'ss' | // subscriber no water damage
  'se' | // subscriber no responce
  'n'  | // closed negative
  'p'  | // closed positive
  'o'  | // opened
  ''
; 
export interface ISubscriberTimelineItem {
  id: number;
  created: number;
  subscriberId: string;
  groupId?: string;
  type: SubscriberTimelineItemType;
  text: string;
  alertCaseId?: number;
}

export type LogType = 
  'cc' | // company created 
  'ce' | // company edited 
  'cd' | // company deactivated 
  'lc' | // sign up link created 
  'dfu' | // Data file uploaded to Claims Analytic 
  'rc' | // New Claim Report compiled 
  'uc' | // user created 
  'ue' | // user edited 
  'ud' | // user deactivated 
  'sl' | // New subscriber enrolled from signup link 
  'se' | // subscriber edited 
  'sd' | // subscriber deactivated
  'di' | // New Device IMEI attached to Subscriber
  '' 
;

export interface ILog {
  id: number,
  date: number;
  userId: string;
  type: LogType;
  aimedUserId?: string
  aimedSubscriberId?: string
  aimedEntityId?: string
  before?: string,
  after?: string,
  other?: string
  groupIds?: {
    deviceId: number,
    groupId: string,
    id: number,
  }[]
}

export type AlertCaseType =
    'E354' | // Communication Error
    'R102' | // Communication Restore
    'E384' | // Low Battery
    'R384' | // Battery Normal
    'E602' | // Communication Test
    'E159' | // Low Temperature
    'R159' | // Temperature Normal
    'E158' | // High Temperature
    'R158' | // Temperature Normal
    'E154' | // Water Alarm
    'R154' | // Water Alarm Cleared
    'E608' | // Abnormal
    'E406'   // No Water
;
export type AlertCaseConclusion = 
  'p' | // positive
  'n' | // negative
  '' |
  null
;